$(document).on("click", ".payment_method", function() {
  var element = $("#registration_service_method")
  var payment_method = $(this).attr('href').split("#")[1].replace("-", "_")

  element.val(payment_method)
})
